// src/pages/ResetPassword.jsx
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Header from '../../components/Header';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback(null);

    // Validation simple
    if (password.length < 6) {
      setFeedback({ type: 'error', message: 'Le mot de passe doit contenir au moins 6 caractères.' });
      return;
    }

    setLoading(true);
    try {
      // Envoie token + nouveau mot de passe dans le body
      const res = await axios.post('https://api.komorotel.com/api/user/reset-password', {
        token,
        newPassword: password,
      });
      setFeedback({ type: 'success', message: 'Mot de passe mis à jour. Redirection...' });
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setFeedback({ type: 'error', message: err.response?.data?.message || 'Erreur inconnue.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header disabled={true} />
      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 10,
            p: 4,
            borderRadius: 3,
            boxShadow: 3,
            bgcolor: 'background.paper',
            textAlign: 'center',
          }}
        >
          <LockResetIcon color="primary" sx={{ fontSize: 50, mb: 1 }} />
          <Typography variant="h5" gutterBottom>
            Réinitialiser votre mot de passe
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Entrez votre nouveau mot de passe ci-dessous.
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Nouveau mot de passe"
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              InputProps={{
                endAdornment: password.length > 0 && (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => setShowPassword((prev) => !prev)}
                      size="small"
                      type="button"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </Button>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="submit"
              disabled={loading}
              sx={{ mt: 2, py: 1.5 }}
            >
              {loading ? <CircularProgress size={24} /> : 'Réinitialiser'}
            </Button>
          </form>

          {feedback && (
            <Alert severity={feedback.type} sx={{ mt: 3 }}>
              {feedback.message}
            </Alert>
          )}
        </Box>
      </Container>
    </>
  );
}
